import { Component, input } from '@angular/core';
import { Rate } from '../../../../shared/models/rate';
import { MatIconModule } from '@angular/material/icon';
import { CurrencyRatePipe } from '../../../../shared/pipes/currency-rate.pipe';
import { NgIf } from '@angular/common';
import { CallForRateComponent } from '../call-for-rate.component';
import { officePhoneNumber } from 'src/app/landing/constants-monisfer-infos';

@Component({
  selector: 'currency-rate-cell',
  imports: [MatIconModule, CurrencyRatePipe, NgIf, CallForRateComponent],
  templateUrl: './currency-rate-cell.component.html',
  styleUrl: './currency-rate-cell.component.scss',
})
export class CurrencyRateCellComponent {
  trade = input.required<'sell' | 'buy'>(); //
  rate = input.required<Rate>();
  readonly monisferOfficeTel = officePhoneNumber;
}
